import {DevicePropertiesErrors} from './device-properties-errors';
import {TranslocoService} from '@ngneat/transloco';
import {DevicePersistRequestCsv} from '../../../model/import-csv/device-persist-request-csv';
import {Inject} from '@angular/core';
import {CsvErrors} from '../../../shared/csv-validation/csv-errors';
import * as moment from 'moment-timezone';

export class DeviceCsvErrors extends CsvErrors<DevicePropertiesErrors, DevicePersistRequestCsv> {
  constructor(@Inject(TranslocoService) i18n: TranslocoService) {
    super(i18n, DevicePropertiesErrors);
  }

  public isFloatNumber(object: DevicePersistRequestCsv, property: string): boolean {
    const nameRegexp: RegExp = /^[+-]?[0-9.]+$/;
    if (object[property] == null || !nameRegexp.test(object[property])) {
      this.addCsvMachineError(property, {
        message: 'needsToBeANumber',
        params: {
          field: this.propertiesErrors.getTranslation(property).toLowerCase(),
          value: object[property]
        }
      });
      return false;
    }
    return true;
  }

  public validLatitude(object: DevicePersistRequestCsv): void {
    let latitude: number = Number.parseFloat(object['latitude']);
    if (object['latitude'] == null || (latitude < -90) && (latitude > 90)) {
      this.addCsvMachineError('latitude', {
        message: 'noValidLatitude',
        params: {
          field: this.propertiesErrors.getTranslation('latitude').toLowerCase(),
          value: object['latitude'],
        }
      });
    }
    return null;
  }

  public validLongitude(object: DevicePersistRequestCsv): void {
    let longitude: number = Number.parseFloat(object['longitude']);
    if (object['longitude'] == null || (longitude < -180) && (longitude > 180)) {
      this.addCsvMachineError('longitude', {
        message: 'noValidLongitude',
        params: {
          field: this.propertiesErrors.getTranslation('longitude').toLowerCase(),
          value: object['longitude'],
        }
      });
    }
    return null;
  }

  public validTimeZone(object: DevicePersistRequestCsv, property: string): void {
    let timeZonesFiltered: string[] = moment.tz.names().filter(name => name === object[property]);

    if (timeZonesFiltered == null || timeZonesFiltered.length == 0) {
      this.addCsvMachineError(property, {
        message: 'noValidTimeZone',
        params: {
          field: this.propertiesErrors.getTranslation(property).toLowerCase(),
          value: object[property],
        }
      });
    }
    return null;
  }

}
